import { render } from "./EvaluationSuggestionListReport.vue?vue&type=template&id=6d4c3a03&scoped=true"
import script from "./EvaluationSuggestionListReport.vue?vue&type=script&lang=js"
export * from "./EvaluationSuggestionListReport.vue?vue&type=script&lang=js"

import "./EvaluationSuggestionListReport.vue?vue&type=style&index=0&id=6d4c3a03&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4c3a03"]])

export default __exports__